import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../variables/api";
import { Card, Grid } from "@material-ui/core";
import { CardHeader, Input } from "reactstrap";
import CardBody from "../../Components/Card/CardBody";
import "./Addticket.css";
import img1 from "../../assets/undraw_Preferences_re_49in.png";
import Button from "../../Components/Button";
import { Link } from "react-router-dom";
import {
  Progress,
  Modal,
  ModalHeader,
  ModalFooter,
  Form,
  ModalBody,
} from "reactstrap";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
interface ITicketData {
  subject: string;
  description: string;
  department: string;
  attachements: any;
  username: string;
}
interface IAttachment {
  id: string;
  name: string;
  file: File;
}

function Addticket(props: any) {
  const [ticketData, setTicketData] = useState<ITicketData>({
    subject: "",
    description: "",
    department: "",
    attachements: [],
    username: "",
  });
  const [departmentData, setDepartmentData] = useState<any>([]);
  const [emailsData, setEmailsData] = useState<any>([]);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [count, setCount] = useState(0);
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState<any>(null);
  const [progress, setProgress] = useState(0);
  const [emailoptions, setEmailOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [attachments, setAttachments] = useState<any>([]);

  const addAttachement = (e: any) => {
    e.preventDefault();
    ticketData.attachements.push({ id: `attachment-${count}`, file: null });
    setAttachments([...ticketData.attachements]);
    setCount(count + 1);
  };
  const handleRemoveattachment = (id: any) => {
    let index = ticketData.attachements.findIndex((a: any) => a.id === id);
    ticketData.attachements.splice(index, 1);
    setTicketData((prevState) => ({
      ...prevState,
      attachements: ticketData.attachements,
    }));
  };
  console.log(ticketData);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const value = e.target.value;

    setTicketData((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const name = e.target.name;
    const value = e.target.value;

    setTicketData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleChangeAttachement = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: any
  ) => {
    const name = e.target.name;
    let attachements = [...ticketData.attachements];
    let index = attachements.findIndex((a: any) => a.id === id);
    if (name === attachements[index].id) {
      if (e.target.files === null) return;
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      attachements[index].file = selectedFile;
    }
    setTicketData((prevState) => ({
      ...prevState,
      attachements: attachements,
    }));
  };

  useEffect(() => {
    axios.get(`${BASE_URL}/tickets/ticketutils.php`).then((res: any) => {
      setDepartmentData(res.data.data.departments);
      const newOptions: { value: string; label: string }[] =
        res.data.data.namesandemails?.map((email: any) => {
          return {
            value: email.username,
            label: `${email.displayname} - ${email.username}`,
          };
        });
      setEmailOptions(newOptions);
    });
  }, []);
  useEffect(() => {
    console.log(document.getElementById("file"));
    ticketData.attachements?.forEach((element: any) => {
      console.log(element);
      if (element.file == null) {
        document.getElementById(element.id)?.click();
      }
    });
    console.log(attachments);
  }, [attachments]);

  const handleSubmitTicket = (e: React.FormEvent) => {
    e.preventDefault();
    Swal.showLoading();
    const formData = new FormData();
    Object.entries(ticketData).forEach(([key, value]) =>
      Array.isArray(value)
        ? value.forEach((attachment) => {
            formData.append(attachment.id, attachment.file);
          })
        : formData.append(key, value)
    );
    setShow(true);
    const res = axios
      .post(`${BASE_URL}/tickets/addticket.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setTicketData((prevstate) => ({
          ...prevstate,
          subject: "",
          description: "",
          department: "",
          attachements: [],
          username: "",
        }));
        setCount(0);

        Swal.fire("Ticket Added Successfully", "", "success").then(() => {
          navigate("/");
        });
      })
      .catch((e) => {
        let ee = e as any;

        Swal.fire(
          ee?.response?.data.msg || "Failed to Add Check Internet Connection",
          "",
          "error"
        );
      });
    // setAttachments((prevState: any) => [...prevState, res.data.data]);
  };

  const customStyles = {
    container: (provided: any) => ({
      ...provided,
      width: "100%",
    }),
  };
  const handleUserSelect = async (selectedOption: any) => {
    setTicketData((prevstate: any) => ({
      ...prevstate,
      username: selectedOption.value,
    }));
  };

  return (
    <div>
      <Link
        style={{ marginTop: "2%" }}
        to="/"
        className="btn btn-secondary mb-3"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>
      <Card>
        <p className="p">Adding a New Ticket</p>
        <CardBody md={12} sm={12} xs={12}>
          <Form onSubmit={handleSubmitTicket}>
            <Grid container>
              <Grid style={{ height: "100%" }} item md={6} sm={12} xs={12}>
                <img
                  style={{ width: "100%", marginTop: "9%", marginLeft: "5%" }}
                  src={img1}
                  alt="ticket booth"
                />
              </Grid>

              <Grid style={{ marginTop: "5%" }} item md={6} sm={12} xs={12}>
                <Grid container>
                  <Grid
                    style={{ marginTop: "2%" }}
                    item
                    md={11}
                    sm={12}
                    xs={12}
                  >
                    <label>Choose Ticket Owner</label>
                    <Select
                      styles={customStyles}
                      options={emailoptions}
                      onChange={handleUserSelect}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item md={11} sm={12} xs={12}>
                    <label>Subject</label>
                    <Input
                      required
                      type="text"
                      value={ticketData.subject}
                      name="subject"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    style={{ marginTop: "2%" }}
                    item
                    md={11}
                    sm={12}
                    xs={12}
                  >
                    <label>Department</label>
                    <Input
                      required
                      type="select"
                      className="form-select"
                      value={ticketData.department}
                      name="department"
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Department
                      </option>
                      {departmentData?.map((d: any) => (
                        <option key={d.id} value={d.id}>
                          {d.department}
                        </option>
                      ))}
                    </Input>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    style={{ marginTop: "2%" }}
                    item
                    md={11}
                    sm={12}
                    xs={12}
                  >
                    <label>Description</label>
                    <textarea
                      required
                      value={ticketData.description}
                      style={{ width: "100%" }}
                      name="description"
                      onChange={handleChangeTextArea}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item md={11} sm={12} xs={12}>
                    <Button
                      style={{ marginLeft: "0px" }}
                      className="btn btn-primary my-4"
                      onClick={(e: any) => {
                        addAttachement(e);
                      }}
                    >
                      Add Attachment
                    </Button>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <th>Attachment</th>
                          <th>Actions</th>
                        </thead>
                        <tbody>
                          {ticketData.attachements?.map(
                            (at: any, index: any) => {
                              return (
                                <tr key={at.id}>
                                  <td>
                                    <Input
                                      type="file"
                                      name={at.id}
                                      id={at.id}
                                      onChange={(e: any) =>
                                        handleChangeAttachement(
                                          e,
                                          `attachment-${index}`
                                        )
                                      }
                                    />
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-danger"
                                      style={{ margin: "auto" }}
                                      onClick={() =>
                                        handleRemoveattachment(at.id)
                                      }
                                    >
                                      Remove
                                    </button>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item md={11} sm={12} xs={12}>
                    <button
                      className="btn btn-primary"
                      style={{ marginLeft: "0" }}
                      type="submit"
                    >
                      Submit
                    </button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
}

export default Addticket;
